import React, { useContext, useRef, useEffect, useState } from "react";
import ModalAllProperties from "./modalAllProperties";
import { API_URLS } from "../api/apiConfig";
import { postWithAuth } from "../api/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../base/context/authcontext";

const MenuProfileItem = ({ userData }) => {
  const [showMenuProfile, setShowMenuProfile] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const menuRef = useRef(null);
  const anchorRef = useRef(null);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setShowMenuProfile(!showMenuProfile);
  };

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenuProfile(false);
      }
    };

    if (showMenuProfile) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenuProfile]);

  useEffect(() => {
    if (showMenuProfile) {
      // Obtenemos las coordenadas del elemento anchor
      const anchorRect = anchorRef.current.getBoundingClientRect();
      const elementWidth = anchorRef.current.offsetWidth;
      // Calculamos la posición del menú
      const screenWidth = window.innerWidth;
      const menuX = anchorRect.left - screenWidth + elementWidth;
      const menuY = anchorRect.top + anchorRect.height + 10;
      setMenuPosition({ x: menuX, y: menuY });
    }
  }, [showMenuProfile]);

  return (
    <>
      <div className="d-flex align-items-center me-4">
        <div
          className="app-navbar-item me-1 me-lg-5"
          id="kt_header_user_menu_toggle"
        >
          <div
            ref={anchorRef}
            onClick={toggleDropdown}
            className="cursor-pointer symbol symbol-40px"
            data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
          >
            <img src="/media/avatars/blank.png" alt="user"></img>
          </div>

          <div
            ref={menuRef}
            style={{
              transform: `translate3d(${menuPosition.x}px, ${menuPosition.y}px, 0)`,
            }}
            className={`menu-profile menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px ${
              showMenuProfile ? "show" : ""
            }`}
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <div className="menu-content d-flex align-items-center px-3">
                <div className="symbol symbol-50px me-5">
                  <img alt="Logo" src="/media/avatars/blank.png"></img>
                </div>
                <div className="d-flex flex-column">
                  <div className="fw-bold d-flex align-items-center fs-5">
                    {userData.name} {userData.last_name}
                  </div>

                  <a className="fw-semibold text-muted fs-7">
                    {userData.email}
                  </a>
                </div>
              </div>
            </div>
            <div className="separator my-2"></div>

            <div className="menu-item px-5">
              <button
                onClick={handleLogout}
                className="menu-link px-5 btn btn-link p-0"
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>

        <div className="d-none d-lg-block m-0">
          <a className="text-gray-800 fs-4 fw-bold">
            {userData.name} {userData.last_name}
          </a>
        </div>
      </div>
    </>
  );
};

const AdminHeader = ({ toggleDrawer, userData }) => {
  const navigate = useNavigate();

  const handleUnlockClick = () => {
    navigate("/planification"); // Cambia '/nueva-ruta' por la ruta a la que quieres navegar
  };

  return (
    <>
      <div id="kt_app_header" className="app-header  d-flex ">
        <div
          className="app-container container-fluid d-flex align-items-stretch justify-content-between"
          id="kt_app_header_container"
        >
          <div
            className="d-flex d-lg-none align-items-center ms-n3 me-2"
            title="Show sidebar menu"
          >
            <div
              className="btn btn-icon btn-active-color-primary w-35px h-35px"
              onClick={toggleDrawer}
              id="kt_app_sidebar_mobile_toggle"
            >
              <i className="ki-outline ki-abstract-14 fs-2"></i>
            </div>
          </div>

          <div className="d-flex d-lg-none align-items-center me-auto">
            <a href="index.html">
              <img
                alt="Logo"
                src="/media/wofyrooms/Aloha_Logo_New_Retina_Blanco.png"
                className="h-35px"
              />
            </a>
          </div>

          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="{default: 'prepend', lg: 'prepend'}"
            data-kt-swapper-parent="{default: '#kt_app_content_container', lg: '#kt_app_header_container'}"
            className="page-title d-flex flex-column justify-content-center me-3 mb-6 mb-lg-0"
          ></div>
          <div
            className="app-navbar flex-stack flex-shrink-0 mt-lg-3 "
            id="kt_app_aside_navbar"
          >
            <div className="app-navbar-item">
              <MenuProfileItem userData={userData} />

              <div
                className="color-background-change-properties btn btn-icon btn-custom btn-light-info btn-active-light-info w-40px h-40px me-4"
                data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
                onClick={handleUnlockClick}
              >
                <i className="fa-solid fa-lock text-color-azul-livensa fs-2x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminHeader;
